// extracted by css-extract-rspack-plugin
export default {"chip":"_d2c25771","disabled":"_462afe33","active":"_763e7b8f"};